import { useMemo } from 'react';
import { IClubMemberDto, ISystemCodeByTypeDto } from '../../../../utils/constants/interfaces';

interface UseMembershipDetailsProps {
  clubMember: IClubMemberDto;
  interests: ISystemCodeByTypeDto[];
  selectedInterests: number[];
}

export const useMembershipDetails = ({
  clubMember,
  interests,
  selectedInterests
}: UseMembershipDetailsProps) => {
  const hasSelectedInterests = useMemo(() => {
    return selectedInterests.length > 0;
  }, [selectedInterests]);

  const availableInterestCount = useMemo(() => {
    return interests.length;
  }, [interests]);

  const selectedInterestCount = useMemo(() => {
    return selectedInterests.length;
  }, [selectedInterests]);

  const hasRequiredMembershipFields = useMemo(() => {
    return Boolean(
      clubMember.membershipTypeId &&
        clubMember.primaryMember.firstJoinedDateUtc &&
        clubMember.primaryMember.joinedDateUtc
    );
  }, [
    clubMember.membershipTypeId,
    clubMember.primaryMember.firstJoinedDateUtc,
    clubMember.primaryMember.joinedDateUtc
  ]);

  return {
    hasSelectedInterests,
    availableInterestCount,
    selectedInterestCount,
    hasRequiredMembershipFields
  };
};
